
import { Mail, LayoutTemplate } from 'lucide-react';
import { NavItem } from '../types';

const emailItems: NavItem[] = [
  {
    title: "Email",
    icon: Mail,
    path: "/app/email/inbox",
    requiredPermissions: ['email.read'],
  },
  {
    title: "Templates",
    icon: LayoutTemplate,
    path: "/app/email-templates",
    requiredPermissions: ['email_template.read'],
  },
];

export default emailItems;
